<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Documentación</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" to="/admin/documentation/form">Agregar nueva sección</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable persistent 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar SECCIÓN</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿ESTA SEGURO DE BORRAR SECCIÓN?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Confirmar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
/* eslint-disable */
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/documentation/settings/',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: {
					types: [],
					localities: [],
					coor_typ: []
				},
				selected: []
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute + 'index').then((res) => {
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
					this.table.loading = false
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
					this.table.loading = false;
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				this.modalDelete.active = false;
				axios.post(this.baseRoute + '/destroy', this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.modalDelete.data = {};
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.$router.push('/admin/documentation/form/' + item.id);
			},
			addETable(){
				this.modalEdit.data.tables.push({
					name: '',
					description: '',
					mask:''
				})
			},
			deleteETable(index){
				this.modalEdit.data.tables.splice(index, 1);
			},
		},
		watch: {

		},
		computed: {

		},
	}
/* eslint-enable */
</script>